<!--
  File name: FormLabel.vue
  Program Description:
    - This component holds & displays the label and the value of the fields
    passed by the `FormRow.vue` component
-->

<template>
  <span>
    <v-row
      v-if="input"
      class="pa-0 ma-0"
    >
      <v-col
        cols="5"
        class="label"
      >
        {{ input.label }}
      </v-col>
      <v-col
        cols="7"
        class="value"
      >
        {{ input.value }}
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  props: {
    input: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped>
  .label {
    font-family: 'Source Sans Pro';
    font-size: 13px;
    padding: 3px;
    margin: 0px;
    font-weight: 600;
  }
  .value {
    font-family: 'Source Sans Pro';
    font-size: 13px;
    padding: 3px;
    margin: 0px;
  }
</style>
